import Shuffle from 'shufflejs';
import * as ScrollMagic from 'scrollmagic';

window.Shuffle = Shuffle;

class CaseStudiesShuffle {
  constructor(element) {
    this.element = element;

    // Initialize Shuffle.js
    this.shuffle = new Shuffle(element, {
      itemSelector: '.filter-tile',
      delimiter: ',',
    });

    window.shuffle = this.shuffle;

    // Log events
    this._activeFilters = [];

    // Automatically apply the filter and sorting if 'service' is present in the query string
    this.applyQueryFilter();

    // Add filter buttons
    this.addFilterButtons();
  }

  // Handle the click event for filter buttons
  _handleFilterClick(evt) {
    const btn = evt.currentTarget;
    const btnGroup = btn.getAttribute('data-group');

    this._removeActiveClass();

    btn.classList.add('filter-active');
    this.shuffle.filter(btnGroup);
    this.reArrangeTermsSubTitle(btnGroup);

    // Sort the items after filtering
    this.sortItemsByCategory(btnGroup);

    // Update the URL with the new query parameter
    this.updateURLWithQueryParam('service', btnGroup);

    this.updateCaseStudyUrl(btnGroup);
  }

  /**
   * Sort items by the category after filtering
   */
  sortItemsByCategory(category) {
    // Use Shuffle's sort method to sort items by a specific data attribute
    this.shuffle.sort({
      by: (element) => {
        // Get the data attribute for the current category, or default to 0
        const orderValue = element.getAttribute(`data-order-${category}`);
        return parseInt(orderValue) || 0; // Convert to integer and default to 0 if not set
      },
      reverse: false, // Set to true if you want to sort in descending order
    });
  }

  /**
   * Shuffle uses the CustomEvent constructor to dispatch events. You can listen
   * for them like you normally would (with jQuery for example).
   */
  updateCaseStudyUrl(service) {


    document.querySelectorAll('.shuffle-item').forEach((item) => {
      let itemLink = item.querySelector('a');
      let url = new URL(itemLink.href);

      // Add 'service' and 'listing' parameters to the URL
      let params = new URLSearchParams({
        listing: window.location.pathname, // The current page path
      });

      if(service) {
        params = new URLSearchParams({
          service: service,
          listing: window.location.pathname, // The current page path
        });
      }

      url.search = params.toString();

      // Update the element's href with the new URL
      itemLink.href = url.toString();
    });



      let serviceText = service;
      let filterlist = document.querySelectorAll('.js-filter-list');
      if(filterlist !== null && filterlist.length > 0) {

        if(service) {

          let filterBtns = Array.from(document.querySelectorAll('.js-filter-list'));
          filterBtns.forEach((button) => {
            if (button.getAttribute('data-group') === service) {
              serviceText = button.innerHTML;

              window.button = button;
            }
          });


          document.querySelector('.select-text').innerHTML = serviceText
        } else {
          document.querySelector('.select-text').innerHTML = 'Please Select';
        }

        document.querySelector('.mobile-navigation__list').classList.remove('mobile-navigation__list--active');

    }






  }


  /**
   * Applies filter based on the 'service' query parameter in the URL.
   */
  applyQueryFilter() {
    const urlParams = new URLSearchParams(window.location.search);
    const serviceFilter = urlParams.get('service');

    if (serviceFilter) {
      this.shuffle.filter(serviceFilter);

      this.setActiveFilterButton(serviceFilter);

      this.reArrangeTermsSubTitle(serviceFilter);

      // Automatically sort items if the service query parameter is present
      this.sortItemsByCategory(serviceFilter);
    }

    this.updateCaseStudyUrl(serviceFilter);


  }

  /**
   * Update the URL with a query parameter without reloading the page.
   */
  updateURLWithQueryParam(key, value) {
    const url = new URL(window.location.href);

    if (value !== null) {
      url.searchParams.set(key, value);
    } else {
        url.searchParams.delete(key); // Optional: Remove the parameter if it exists
    }
      // Update the URL without reloading the page
      window.history.pushState({}, '', url);

  }

  reArrangeTermsSubTitle(service) {
    // Select all elements with a class containing the service slug
    const termTitles = document.querySelectorAll(`.termname-${service}`);

    if (termTitles !== null && termTitles.length > 0) {
      termTitles.forEach((termTitle) => {
        // Find all span elements within the parent element (sub-heading)
        const termSpans = termTitle.parentElement.querySelectorAll('span');

        // Convert NodeList to an array for easy manipulation
        const termsArray = Array.from(termSpans);

        // Remove the selected term from its current position
        termsArray.splice(termsArray.indexOf(termTitle), 1);

        // Rearrange terms: Put the selected term at the beginning
        termsArray.unshift(termTitle);

        // Loop through terms to control visibility and dynamically add '+' separators
        termsArray.forEach((term, index) => {
          if (index < 2) {
            // Show the first two terms
            term.style.display = 'inline';
          } else {
            // Hide all terms after the first two
            term.style.display = 'none';
          }
        });
      });
    }
  }




  /**
   * Finds the filter button with the matching 'data-group' attribute
   * and sets it as active.
   */
  setActiveFilterButton(service) {

    const filterButtons = Array.from(document.querySelectorAll('.js-filter-list'));
    filterButtons.forEach((button) => {
      if (button.getAttribute('data-group') === service) {
        button.classList.add('filter-active');
      }
    });
  }

  addFilterButtons() {
    const options = document.querySelectorAll('.filter-options .sub-navigation__item');
    if (!options) {
      return;
    }

    const filterButtons = Array.from(options);
    const onClick = this._handleFilterClick.bind(this);
    filterButtons.forEach((button) => {

      if(button.querySelector('a') !== null) {
        button.querySelector('a').onclick = function(e) {
          e.preventDefault();
          document.querySelector('.mobile-navigation__list--active').classList.remove('mobile-navigation__list--active');
        }
      }

      button.addEventListener('click', onClick, false);
    });
  }

  _removeActiveClass() {
    let filters = document.querySelectorAll('.sub-navigation__item.filter-active');

    if(filters.length > 0) {
      filters.forEach((item) => {
        item.classList.remove('filter-active');
      })
    }
  }
}



class CaseStudiesFilter {
  constructor() {
    this.controller = null; // Store the ScrollMagic controller
    this.subNavigation = null;
    this.subNavigationTrigger = null;
    this.mainContent = null;
    this.header = null;
    this.caseStudies = null;

    // Bind the event handler to this instance
    this.handleFilterButtonClick = this.handleFilterButtonClick.bind(this);

    // Attach the delegated event listener to the document
    document.addEventListener('click', this.handleFilterButtonClick);
  }

  // Initialize or reinitialize your components
  initComponents() {
    this.caseStudies = document.querySelectorAll('.casestudies');
    this.subNavigation = document.querySelector('.sub-navigation');
    this.subNavigationTrigger = document.querySelector('.sub-navigation-trigger');
    this.mainContent = document.querySelector('.main-content');
    this.header = document.querySelector('.header');

    // Clean up any previous instances
    this.teardown();

    // Initialize CaseStudiesShuffleFilter if elements are present
    if (this.caseStudies.length > 0) {
      this.caseStudies.forEach((caseStudy) => {
        new CaseStudiesShuffle(caseStudy);
      });
    }

    // Set up ScrollMagic if necessary elements are present
    if (this.caseStudies.length > 0 && this.subNavigationTrigger) {
      this.subNavigation.classList.remove('sub-navigation--scrolled');
      this.mainContent.style.zIndex = '1';
      this.header.style.zIndex = '999';

      this.subNavigationTrigger.style.height = `${this.subNavigation.offsetHeight}px`;

      // Create a new ScrollMagic controller
      this.controller = new ScrollMagic.Controller();

      const caseStudiesElement = document.querySelector('.casestudies');

      // Check if caseStudiesElement exists before using it in the scene duration
      const sceneDuration = caseStudiesElement ? Math.max(0, caseStudiesElement.offsetHeight - 100) : 0;

      const scene = new ScrollMagic.Scene({
        triggerElement: '.casestudies',
        triggerHook: 0,
        duration: sceneDuration, // Use the calculated duration
      }).addTo(this.controller);

      // Add class when pinned
      scene.on('enter', () => {
        this.subNavigation.classList.add('sub-navigation--scrolled');
        this.mainContent.style.zIndex = '9';
        this.header.style.zIndex = '2';
      });

      // Remove class when unpinned
      scene.on('leave', () => {
        this.subNavigation.classList.remove('sub-navigation--scrolled');
        this.mainContent.style.zIndex = '1';
        this.header.style.zIndex = '999';
      });
    }
  }

  // Event handler for the filter button click
  handleFilterButtonClick(event) {
    // Check if the event target matches the filter button
    if (event.target.matches('.js-filter-button')) {
      event.preventDefault();
      this.subNavigation.classList.toggle('sub-navigation--open');
    }
  }

  // Teardown function to remove all instances and clean up
  teardown() {
    // Destroy any existing ScrollMagic controller and scenes
    if (this.controller) {
      this.controller.destroy(true); // Destroy the controller and all scenes
      this.controller = null; // Reset the controller
    }
  }
}


export default CaseStudiesFilter;



// WEBPACK FOOTER //
// ./scripts/blocks/case-studies.js